module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "add-brand-button",
    on: {
      "click": _vm.showModalAddBranded
    }
  }, [_vm._v("ADD NEW BRANDED ARTICLE")]), _vm._v(" "), (_vm.showBrandedModal) ? _c('modal-branded', {
    attrs: {
      "modal": _vm.showBrandedModal,
      "passedValue": _vm.probTotal
    },
    on: {
      "update:modal": function($event) {
        _vm.showBrandedModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("ARTICLE SLUG")]), _vm._v(" "), _c('th', [_vm._v("ACTIVE")]), _vm._v(" "), _c('th', [_vm._v("LOCATION")]), _vm._v(" "), _c('th', [_vm._v("TARGETED PAGEVIEWS")]), _vm._v(" "), _c('th', [_vm._v("CURRENT PAGEVIEWS")]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    class: _vm.order.startDate !== null ? (_vm.order.startDate ? 'asc' : 'desc') : '',
    on: {
      "click": function($event) {
        _vm.sort('startDate')
      }
    }
  }, [_c('div', [_vm._v("\n            CAMPAIGN START DATE\n            "), _c('svg', {
    staticClass: "up-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    class: _vm.order.endDate !== null ? (_vm.order.endDate ? 'asc' : 'desc') : '',
    on: {
      "click": function($event) {
        _vm.sort('endDate')
      }
    }
  }, [_c('div', [_vm._v("\n          CAMPAIGN END DATE\n          "), _c('svg', {
    staticClass: "up-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])])]), _vm._v(" "), _c('th', [_vm._v("PROBABILITY OF SURFACING")]), _vm._v(" "), _c('th', [_vm._v("% PV TARGET LIKELY TO BE ACHIEVED")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.brandedData), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(item.data.url))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.location ? item.data.location : 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.pageviews))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.currentPageviews))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.startDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.endDate))]), _vm._v(" "), _c('td', {
      staticClass: "probability"
    }, [_vm._v(_vm._s(item.data.probability)), (item.data.location !== 'All States' && item.data.location !== undefined) ? _c('span', [_vm._v(" " + _vm._s(_vm.adjustProbForState(item.data)))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.brandedDataCalculatedDelivery[key] ? ((_vm.brandedDataCalculatedDelivery[key]) + " %") : "N/A"))]), _vm._v(" "), _c('td', [_c('modal-editbrand', {
      attrs: {
        "passedItem": item
      }
    })], 1), _vm._v(" "), _c('td', [_c('modal-delbrand', {
      attrs: {
        "passedItem": item
      }
    })], 1)])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-313afd9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/branded.vue
// module id = 641
// module chunks = 1